import { render } from "./AddonDigitalFree.vue?vue&type=template&id=3199362a&scoped=true"
import script from "./AddonDigitalFree.vue?vue&type=script&lang=js"
export * from "./AddonDigitalFree.vue?vue&type=script&lang=js"

import "./AddonDigitalFree.vue?vue&type=style&index=0&id=3199362a&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3199362a"]])

export default __exports__